import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import Header from '../global/components/Header'
import SEO from '../global/components/SEO'

// import the primary stylesheet
import '../global/styles/style.scss'


const TemplateWrapper = ({ children, location }) => {

  let content_class = 'default--typography';
  if ( location.pathname === '/newsletter' ) { content_class += ' flex'; }



  const title = ' | Dhruv Kumar Jha';
  let seo_data = {
    title: 'Dhruv Kumar Jha - Entrepreneur, Full Stack Architect.',
    description: 'Full Stack Developer and Architect, Working with Node, Javascript, React, GraphQL, MongoDB, Serverless and Everything In Between. Love Building Applications for Consumers and Enterprises.',
    keywords: 'Dhruv Kumar Jha, Dhruv Kumar, Dhruv, Dhruv Jha, DKJ, Full Stack Architect, Full Stack Developer, Lambda Developer, Entrepreneur, Node JS, Javascript, React JS, GraphQL',
  };


  if ( location.pathname === '/newsletter' ) {
    seo_data = {
      title: `Newsletter ${ title }`,
      description: 'Subscribe to my Newsletter',
      keywords: 'Newsletter, Dhruv Kumar Jha Newsletter, Tutorial Newsletter',
    }
  }
  if ( location.pathname === '/articles' ) {
    seo_data = {
      title: `Articles and Tutorials ${ title }`,
      description: 'Some of the Articles and Tutorials on Frontend and Backend Development written by me.',
      keywords: 'Node JS, React JS, Javascript, GraphQL, AI, Alexa, Apollo, Webpack, AntD, CSS, HTML, AWS, Lambda',
    }
  }
  if ( location.pathname === '/open-source' ) {
    seo_data = {
      title: `Open Source ${ title }`,
      description: 'These are Some of the Open Source projects I have worked on and contributed to.',
      keywords: 'Open Source, Github, Productivity App, AWS Lambda, GraphQL Documentation Generator',
    }
  }
  if ( location.pathname === '/store' ) {
    seo_data = {
      title: `Ebooks, Video Tutorials and Tshirts ${ title }`,
      description: 'Buy premium Ebooks, Video tutorials written my me and some T-shirts designed by me.',
      keywords: 'Store, Shopping, Ebooks, Javascript, Tshirts',
    }
  }
  if ( location.pathname === '/archive' ) {
    seo_data = {
      title: `Archived Articles ${ title }`,
      description: `These are the Articles I had published before Updating the UI of the website`,
      keywords: 'Archived, V1, Dhruv Kumar Jha',
    }
  }
  if ( location.pathname === '/contact' ) {
    seo_data = {
      title: `Contact Me ${ title }`,
      description: `Get in touch with me`,
      keywords: 'Dhruv Kumar Jha, Contact Me, Get In Touch, Contact Information',
    }
  }


  seo_data.url = location.pathname;
  seo_data.type = 'page';







  return (
    <div>

      <SEO data={ seo_data } />

      <Header />

      <div className="wrapper--default-pages">
        <div className={ content_class }>
          { children() }
        </div>
      </div>

    </div>
  )

}


export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js